import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';

const styles = () =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 12,
      padding: '12px 24px',
      backgroundColor: '#dc2626',
      color: '#fff',
      fontFamily: 'GolosTextWebMedium, Roboto',
      fontSize: 14,
      lineHeight: '20px',
    },
    icon: {
      flexShrink: 0,
      fontSize: 20,
    },
    text: {
      margin: 0,
    },
    link: {
      color: 'inherit',
      textDecoration: 'underline',
      whiteSpace: 'nowrap',
    },
  });

interface IProps extends WithStyles<typeof styles> {
  newVersionHref?: string;
}

const SunsetBanner: React.FC<IProps> = ({ classes, newVersionHref = 'https://lk.guestme.ru/' }) => (
  <div className={classes.container} role="alert">
    <ErrorOutlineIcon className={classes.icon} />
    <p className={classes.text}>
      С 1 ноября 2026 г. старая версия личного кабинета перестанет поддерживаться. Пожалуйста,
      переключитесь на{' '}
      <a className={classes.link} href={newVersionHref}>
        новую версию
      </a>
      . Поддержка:{' '}
      <a className={classes.link} href="mailto:support@guestme.ru">
        support@guestme.ru
      </a>
      ,{' '}
      <a className={classes.link} href="tel:+79661578569">
        +7 966 157-85-69
      </a>
      .
    </p>
  </div>
);

export default withStyles(styles)(SunsetBanner);
